module.exports = "<div class=\"panolens-container-app\" #panolens ></div>\n"